var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgArrowWallRight(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M21.25 4C21.6642 4 22 4.33579 22 4.75V19.25C22 19.6642 21.6642 20 21.25 20C20.8358 20 20.5 19.6642 20.5 19.25V4.75C20.5 4.33579 20.8358 4 21.25 4ZM12.9697 7.21967C13.2626 6.92678 13.7374 6.92678 14.0303 7.21967L17.2196 10.409C18.0983 11.2876 18.0984 12.7123 17.2196 13.5909C17.2196 13.5909 17.2196 13.591 17.2196 13.591L14.0303 16.7803C13.7374 17.0732 13.2626 17.0732 12.9697 16.7803C12.6768 16.4874 12.6768 16.0126 12.9697 15.7197L15.9392 12.75H2.75C2.33579 12.75 2 12.4142 2 12C2 11.5858 2.33579 11.25 2.75 11.25H15.9393L12.9697 8.28033C12.6768 7.98744 12.6768 7.51256 12.9697 7.21967Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrowWallRight);
export default __webpack_public_path__ + "static/media/arrow-wall-right.6da889fe85b606ca642364192dece0f4.svg";
export { ForwardRef as ReactComponent };